import type { Match } from "./sim/Match";

export const session = {
  levelIndex: 1,
  match: null as Match | null,
  restarting: false,
};
